import { useState, useCallback } from 'react';
import deliveryOrderService from '../services/deliveryOrderService';

const useMySubOrders = () => {
    const [items, setItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const [detailLoading, setDetailLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchList = useCallback(async (params = {}) => {
        setLoading(true);
        setError(null);
        const res = await deliveryOrderService.getMySubOrders(params);
        setLoading(false);
        if (res.success) {
            const data = res.data;
            setItems(Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : []);
            setTotal(data?.total ?? 0);
        } else {
            setError(res.error);
        }
    }, []);

    const fetchDetail = useCallback(async (id) => {
        setDetailLoading(true);
        setDetail(null);
        const res = await deliveryOrderService.getSubOrderDetail(id);
        setDetailLoading(false);
        if (res.success) setDetail(res.data);
        return res;
    }, []);

    const clearDetail = useCallback(() => setDetail(null), []);

    return { items, total, loading, detail, detailLoading, error, fetchList, fetchDetail, clearDetail };
};

export default useMySubOrders;
